import { apiClient } from './client';

export interface Court {
  id: number;
  name: string;
  address: string;
  city: string;
  zip_code: string;
  country: string;
  courts_count: number;
  booking_url?: string;
  padelmap_url?: string;
  price_per_hour?: number;
  is_active: boolean;
  created_at: string;
}

export const courtsApi = {
  list: (city?: string) => apiClient.get<Court[]>('/api/courts', { params: city ? { city } : {} }),
  create: (data: Omit<Court, 'id' | 'is_active' | 'created_at'>) => apiClient.post<Court>('/api/courts', data),
  update: (id: number, data: Partial<Court>) => apiClient.put<Court>(`/api/courts/${id}`, data),
  delete: (id: number) => apiClient.delete(`/api/courts/${id}`),
};
